module.exports = __webpack_public_path__ + "static/beach-5b1fdd45e13930a6f10e1b67171b61ec.jpg";